import * as Yup from 'yup';
import { TFunction } from 'i18next';

export const createSchema = (t: TFunction) => Yup.object().shape({
  description: Yup.string().required(t('cadastroDisciplina.schemaRequired')),
});

export default createSchema;
